import PlantSubServicePage from "@/components/PlantSubServicePage";

const RELATED = [
  { to: "/piping", label: "Piping" },
  { to: "/civil-structural", label: "Civil & Structural" },
  { to: "/mechanical", label: "Mechanical" },
  { to: "/materials", label: "Material (MTC)" },
];

export default function ElectricalInstrumentation() {
  return (
    <PlantSubServicePage
      slug="electrical-instrumentation"
      title="Electrical & Instrumentation"
      lead="E&I design and engineering across heavy industries — optimal performance with compliance, every time."
      intro={[
        "ZeroLabs Digitals' Electrical & Instrumentation (E&I) team offers extensive experience in design and engineering across Oil & Gas, Refining, Petrochemicals, Chemicals, Pharmaceuticals, Power, Water Treatment and Paper & Pulp.",
        "We provide tailored E&I solutions that ensure optimal performance and compliance with industry standards.",
        "Our team is proficient in leading software tools for E&I design — Autodesk, AVEVA and Bentley — enabling us to deliver precise and reliable results for your projects.",
      ]}
      industries={["Oil & Gas", "Refining", "Petrochemicals", "Chemicals", "Pharmaceuticals", "Power", "Water Treatment", "Paper & Pulp"]}
      tools={["Autodesk AutoCAD Electrical", "AVEVA Electrical", "Bentley Substation", "ETAP", "SmartPlant Instrumentation"]}
      heroImage="https://www.thantrick.com/wp-content/uploads/2025/04/electrical.jpg"
      gallery={[
        "https://www.thantrick.com/wp-content/uploads/2025/04/Electrical-Instrumentation-300x200.jpg",
        "https://www.thantrick.com/wp-content/uploads/2025/04/electrical-300x201.jpg",
      ]}
      thantrickUrl="https://thantrick.org/electrical-instrumentation-2/"
      related={RELATED}
    />
  );
}
